import { ContentBlockerWrapper } from "@aleksundshantu/aunds-cookie-plugin-react";
import { ReactNode } from "react";

interface ExtendedConsentManagementProps {
  children: ReactNode;
  type_consent_management: string;
}

export const ExtendedConsentManagement = ({
  type_consent_management,
  children,
}: ExtendedConsentManagementProps) => {
  const hasConsent = !!type_consent_management;

  return hasConsent ? (
    <>{children}</>
  ) : (
    <ContentBlockerWrapper
      wpApiUrl={process.env.WP_API_URL!}
      platformName={type_consent_management || "unknown"}
    >
      {children}
    </ContentBlockerWrapper>
  );
};
